import { Component, Input } from '@angular/core';
import { IndicatorDotComponent } from '../indicator-dot/indicator-dot.component';
import { CommonModule } from '@angular/common';
import { IconToolTipComponent } from '../icon-tool-tip/icon-tool-tip.component';
import { FlexModule } from '@angular/flex-layout';

@Component({
  selector: 'app-portal-data-element-list-indicator-element',
  standalone: true,
  imports: [
    CommonModule,
    IndicatorDotComponent,
    IconToolTipComponent,
    FlexModule,
  ],
  templateUrl: './portal-data-element-list-indicator-element.component.html',
  styleUrl: './portal-data-element-list-indicator-element.component.scss',
})
export class PortalDataElementListIndicatorElementComponent {
  @Input({ required: true }) itemName!: string;
  @Input({ required: false }) tooltipText?: string;
  @Input({ required: false }) nbCompleted?: number;
  @Input({ required: false }) nbNotCompleted?: number;
  @Input({ required: false }) nbDisplay?: number;
}
